
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.035 4.757a4.05 4.05 0 014.05-4.05h1.5a4.05 4.05 0 014.05 4.05v13.222h-.004v.276a4.05 4.05 0 01-4.05 4.05H4.684a4.05 4.05 0 01-4.05-4.05v-.556a4.05 4.05 0 014.05-4.05h2.544v-2.44a4.05 4.05 0 014.05-4.05h3.758V4.758z"}})]),_c('path',{attrs:{"d":"M24.635 17.979v2h2v-2h-2zm-.004 0v-2h-2v2h2zm-17.404-4.33v2h2v-2h-2zm7.808-6.49v2h2v-2h-2zm4.05-8.452a6.05 6.05 0 00-6.05 6.05h4a2.05 2.05 0 012.05-2.05v-4zm1.5 0h-1.5v4h1.5v-4zm6.05 6.05a6.05 6.05 0 00-6.05-6.05v4a2.05 2.05 0 012.05 2.05h4zm0 13.222V4.757h-4v13.222h4zm-2.004 2h.004v-4h-.004v4zm-2-2v.276h4v-.276h-4zm0 .276a2.05 2.05 0 01-2.05 2.05v4a6.05 6.05 0 006.05-6.05h-4zm-2.05 2.05H4.684v4h15.899v-4zm-15.898 0a2.05 2.05 0 01-2.05-2.05h-4a6.05 6.05 0 006.05 6.05v-4zm-2.05-2.05v-.556h-4v.556h4zm0-.556a2.05 2.05 0 012.05-2.05v-4a6.05 6.05 0 00-6.05 6.05h4zm2.05-2.05h2.544v-4H4.683v4zm.544-4.44v2.44h4v-2.44h-4zm6.05-6.05a6.05 6.05 0 00-6.05 6.05h4a2.05 2.05 0 012.05-2.05v-4zm3.758 0h-3.759v4h3.76v-4zm-2-.402V7.16h4V4.757h-4z","fill":"#339299","mask":"url(#a)"}})])
          )
        }
      }
    